import React from "react";
import PropTypes from "prop-types";
import { noop } from "lodash";
import Document from "./Document";

class DocumentRenderer extends React.Component {
  state = {};
  static propTypes = {
    onContentChanged: PropTypes.func,
    bodyOnly: PropTypes.bool,
    template: PropTypes.string,
    visible: PropTypes.bool,
  };
  static defaultProps = {
    onContentChanged: noop,
    bodyOnly: true,
    template: "/templates/document.html",
    visible: false,
  };

  componentDidMount = () => {
    this.frame.addEventListener("load", this.handleLoad, true);
  };

  componentWillUnmount = () => {
    this.frame.removeEventListener("load", this.handleLoad, true);
    delete this.frame;
  };

  handleLoad = () => {
    const root = this.frame.contentDocument.querySelector("#root");
    this.setState({ root });
  };

  componentDidUpdate = () => {
    if (this.state.root && this.frame) {
      const { content } = this;
      const { contentDocument } = this.frame;
      this.content = this.props.bodyOnly
        ? contentDocument.body.innerHTML
        : contentDocument.getElementsByTagName("html")[0].innerHTML;
      if (content !== this.content) this.props.onContentChanged(this.content);
    }
  };

  render = () => {
    const {
      state: { root },
      props: { children, onContentChanged, bodyOnly, ...props },
    } = this;

    return (
      <Document getRef={(el) => (this.frame = el)} root={root} {...props}>
        {children}
      </Document>
    );
  };
}

export default DocumentRenderer;
